/**
 * Portaled Radix DropdownMenu content sits outside DialogContent, so the
 * dialog treats menu clicks as "outside" and dismisses. Prevent that when the
 * event target is inside a dropdown menu portal (AD-2098).
 */
const DROPDOWN_MENU_PORTAL_SLOTS = [
  '[data-slot="dropdown-menu-content"]',
  '[data-slot="dropdown-menu-sub-content"]',
] as const;

export function preventDialogDismissForDropdown(event: {
  target: EventTarget | null;
  preventDefault: () => void;
}): void {
  if (!(event.target instanceof Element)) return;
  const target = event.target;
  if (DROPDOWN_MENU_PORTAL_SLOTS.some((slot) => target.closest(slot) != null)) {
    event.preventDefault();
  }
}
